import type { GameTileConfig } from "@hunch/core";

/**
 * All requests go to the same origin (spec §2: no third-party requests). In
 * dev, Vite proxies /api to the Fastify dev server (see vite.config.ts).
 */
async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(path, { credentials: "omit" });
  if (!res.ok) throw new Error(`Request failed: ${path} (${res.status})`);
  return (await res.json()) as T;
}

export function fetchGameTiles(): Promise<GameTileConfig[]> {
  return getJson<GameTileConfig[]>("/api/public/game-tiles");
}

export interface PublicPage {
  slug: string;
  lang: string;
  markdown: string;
}

export async function fetchPage(slug: string, lang: string): Promise<PublicPage | null> {
  const res = await fetch(`/api/public/pages/${slug}/${lang}`, { credentials: "omit" });
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`Request failed: pages/${slug}/${lang} (${res.status})`);
  return (await res.json()) as PublicPage;
}
